import { deviation } from "d3-array";

import { last, slidingWindow, zipper, getSourcePathAccessor } from "../utils";
import getMACalculator from "../utils/getMACalculator";

import { BollingerPercentB as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { windowSize, multiplier, movingAverageType, sourcePath } = options;

    const source = getSourcePathAccessor(sourcePath);
    // Use centralized MA calculator for all moving average types
    const maCalculator = getMACalculator(movingAverageType || "sma");
    const meanAlgorithm = maCalculator().options({ windowSize, sourcePath });

    const bollingerPercentBAlgorithm = slidingWindow()
      .windowSize(windowSize)
      .accumulator((values) => {
        const avg = last(values).mean;
        const price = source(last(values).datum);
        const stdDev = deviation(values, (each) => source(each.datum));

        const upperBand = avg + multiplier * stdDev;
        const lowerBand = avg - multiplier * stdDev;
        const bandWidth = upperBand - lowerBand;

        // %b = (Price - Lower Band) / (Upper Band - Lower Band)
        // Result is typically between 0-1, multiply by 100 for 0-100 range
        if (bandWidth === 0) return undefined;

        const percentB = ((price - lowerBand) / bandWidth) * 100;
        return percentB;
      });

    const zip = zipper().combine((datum, mean) => ({ datum, mean }));

    const tuples = zip(data, meanAlgorithm(data));
    return bollingerPercentBAlgorithm(tuples);
  }

  calculator.undefinedLength = function () {
    const { windowSize } = options;
    return windowSize - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
